<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>


  <!--This is the form that is popup from list at http://localhost:4201/features-->


  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      @if (!showPropertyFeatureTemplate) {
        <div class="row m-0">
          <div class="col-lg-12">
            @if (formAlert) {
              <div class="w-100 mb-3">
                <div class="w-100"
                  style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                  <p><b>{{formAlert}}</b></p>
                </div>
              </div>
            }
          </div>
          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="title" id="title" type="text" pInputText>
              <label for="title">Title</label>
              @for (validation of validationMessages.title; track validation) {
                <span>
                  @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <!--<div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
              optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
              placeholder="Select Property">
            </p-dropdown>
            <label for="Select Property">Select Property</label>
            <span *ngFor="let validation of validationMessages.shortTermRentalId">
              <small class="p-invalid"
                *ngIf="form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>-->
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="featureType" id="featureType" type="text" pInputText>
            <label for="featureType">feature Type</label>
            @for (validation of validationMessages.featureType; track validation) {
              <span>
                @if (form1.get('featureType').hasError(validation.type) && (form1.get('featureType').dirty || form1.get('featureType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="featureLabel" id="featureLabel" type="text" pInputText>
            <label for="featureLabel">feature Label</label>
            @for (validation of validationMessages.featureLabel; track validation) {
              <span>
                @if (form1.get('featureLabel').hasError(validation.type) && (form1.get('featureLabel').dirty || form1.get('featureLabel').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <!-- <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="defaultFeature" id="defaultFeature" type="text" pInputText>
          <label for="defaultFeature">Default Feature</label>
          <span *ngFor="let validation of validationMessages.defaultFeature">
            <small class="p-invalid"
              *ngIf="form1.get('defaultFeature').hasError(validation.type) && (form1.get('defaultFeature').dirty || form1.get('defaultFeature').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div> -->
      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="defaultFeatures" formControlName="defaultFeature" optionLabel="name"
            optionValue="value" placeholder="Default Feature">
          </p-dropdown>
          <label for="defaultFeature">Default Feature</label>
          @for (validation of validationMessages.defaultFeature; track validation) {
            <span>
              @if (form1.get('defaultFeature').hasError(validation.type) && (form1.get('defaultFeature').dirty || form1.get('defaultFeature').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <!-- <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="defaultHighlight" id="defaultHighlight" type="number" pInputText>
        <label for="defaultHighlight">Default Highlight</label>
        <span *ngFor="let validation of validationMessages.defaultHighlight">
          <small class="p-invalid"
            *ngIf="form1.get('defaultHighlight').hasError(validation.type) && (form1.get('defaultHighlight').dirty || form1.get('defaultHighlight').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div> -->
    <div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <p-dropdown [options]="highlights" formControlName="defaultHighlight" optionLabel="name"
          optionValue="value" placeholder="Default Highlight">
        </p-dropdown>
        <label for="defaultHighlight">Default Highlight</label>
        @for (validation of validationMessages.defaultHighlight; track validation) {
          <span>
            @if (form1.get('defaultHighlight').hasError(validation.type) && (form1.get('defaultHighlight').dirty || form1.get('defaultHighlight').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <textarea formControlName="featureDesc" id="featureDesc" [rows]="1" pInputTextarea></textarea>
        <label for="featureDesc">feature Description</label>
        @for (validation of validationMessages.featureDesc; track validation) {
          <span>
            @if (form1.get('featureDesc').hasError(validation.type) && (form1.get('featureDesc').dirty || form1.get('featureDesc').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="quantity" id="quantity" type="number" pInputText>
        <label for="quantity">Quantity</label>
        @for (validation of validationMessages.quantity; track validation) {
          <span>
            @if (form1.get('quantity').hasError(validation.type) && (form1.get('quantity').dirty || form1.get('quantity').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <!-- <input formControlName="describesType" id="describesType" type="text" pInputText>
    <label for="describesType">Describes Type</label> -->
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <p-multiSelect class="lead-select" [options]="describesTypes" formControlName="describesType" appendTo="body"
        defaultLabel="Describes Type" optionLabel="name" display="chip"></p-multiSelect>
        <label for="describesType">Describes Type</label>
        @for (validation of validationMessages.describesType; track validation) {
          <span>
            @if (form1.get('describesType').hasError(validation.type) && (form1.get('describesType').dirty || form1.get('describesType').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="kbmMap" id="kbmMap" type="text" pInputText>
        <label for="kbmMap">KBM Map</label>
        @for (validation of validationMessages.kbmMap; track validation) {
          <span>
            @if (form1.get('kbmMap').hasError(validation.type) && (form1.get('kbmMap').dirty || form1.get('kbmMap').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="vrboMap" id="vrboMap" type="text" pInputText>
        <label for="vrboMap">Vrbo Map</label>
        @for (validation of validationMessages.vrboMap; track validation) {
          <span>
            @if (form1.get('vrboMap').hasError(validation.type) && (form1.get('vrboMap').dirty || form1.get('vrboMap').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="rentalsUnitedMap" id="rentalsUnitedMap" type="text" pInputText>
        <label for="rentalsUnitedMap">Rentals UnitedMap</label>
        @for (validation of validationMessages.rentalsUnitedMap; track validation) {
          <span>
            @if (form1.get('rentalsUnitedMap').hasError(validation.type) && (form1.get('rentalsUnitedMap').dirty || form1.get('rentalsUnitedMap').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="airbnbCode" id="airbnbCode" type="text" pInputText>
        <label for="airbnbCode">Airbnb Code</label>
        @for (validation of validationMessages.airbnbCode; track validation) {
          <span>
            @if (form1.get('airbnbCode').hasError(validation.type) && (form1.get('airbnbCode').dirty || form1.get('airbnbCode').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="bookingcomCode" id="bookingcomCode" type="text" pInputText>
        <label for="bookingcomCode">Bookingcom Code</label>
        @for (validation of validationMessages.bookingcomCode; track validation) {
          <span>
            @if (form1.get('bookingcomCode').hasError(validation.type) && (form1.get('bookingcomCode').dirty || form1.get('bookingcomCode').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="expediaCode" id="expediaCode" type="text" pInputText>
        <label for="expediaCode">Expedia Code</label>
        @for (validation of validationMessages.expediaCode; track validation) {
          <span>
            @if (form1.get('expediaCode').hasError(validation.type) && (form1.get('expediaCode').dirty || form1.get('expediaCode').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="googleCode" id="googleCode" type="text" pInputText>
        <label for="googleCode">Google Code</label>
        @for (validation of validationMessages.googleCode; track validation) {
          <span>
            @if (form1.get('googleCode').hasError(validation.type) && (form1.get('googleCode').dirty || form1.get('googleCode').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="marriottCode" id="marriottCode" type="text" pInputText>
        <label for="marriottCode">Marriott Code</label>
        @for (validation of validationMessages.marriottCode; track validation) {
          <span>
            @if (form1.get('marriottCode').hasError(validation.type) && (form1.get('marriottCode').dirty || form1.get('marriottCode').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="vrboCode" id="vrboCode" type="text" pInputText>
        <label for="vrboCode">Vrbo Code</label>
        @for (validation of validationMessages.vrboCode; track validation) {
          <span>
            @if (form1.get('vrboCode').hasError(validation.type) && (form1.get('vrboCode').dirty || form1.get('vrboCode').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6">
      <span class="p-float-label w-100 mb-3">
        <textarea formControlName="privateNotes" id="privateNotes" [rows]="1" pInputTextarea></textarea>
        <label for="privateNotes">Private Notes</label>
        @for (validation of validationMessages.privateNotes; track validation) {
          <span>
            @if (form1.get('privateNotes').hasError(validation.type) && (form1.get('privateNotes').dirty || form1.get('privateNotes').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  </div>
}
@if (showPropertyFeatureTemplate) {
  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3">
      <p-dropdown [options]="propertyFeatureTempletes" formControlName="propertyFeatureTemplateId" optionLabel="templateName"
        optionValue="propertyFeatureTemplateId" [filter]="true" filterBy="templateName" [showClear]="false" appendTo="body"
        placeholder="Select Property Feature Template">
      </p-dropdown>
      <label for="Select Property Feature Template">Select Property Feature Template</label>
      @for (validation of validationMessages.propertyFeatureTemplateId; track validation) {
        <span>
          @if (form1.get('propertyFeatureTemplateId').hasError(validation.type) && (form1.get('propertyFeatureTemplateId').dirty || form1.get('propertyFeatureTemplateId').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
}
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>

        @if (!featureId && !showPropertyFeatureTemplate) {
          <button pButton class="btn-addt p-button" (click)="formAdd()">Add Feature</button>
        }

        @if (!featureId && showPropertyFeatureTemplate) {
          <button pButton class="btn-addt p-button" (click)="formAdd()">Submit</button>
        }

        @if (featureId && !showPropertyFeatureTemplate) {
          <button pButton class="btn-upt p-button" (click)="copyToFeature()">Copy To</button>
        }

        @if (featureId && !showPropertyFeatureTemplate) {
          <button pButton class="btn-upt p-button" (click)="formUpdate()">Update
          Feature</button>
        }
      </div>
    </div>
  </div>
</div>